import { Endpoint } from '../endpoint';

export const DataElement = new Endpoint('data_element');
